// Copyright (c) 2017 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledDateInput from '../../../../claim/shared/components/claim-fields/labeled-date-input';
import moment from 'moment';

class SystemSelectedClaimsModalBody extends Component {

    state = {
        fromDate: moment.utc().subtract(30, 'days').startOf('day')
            .valueOf(),
        toDate: moment.utc().endOf('day')
            .valueOf()
    };

    handleFromDateChange = fromDate =>
        this.setState({fromDate});

    handleToDateChange = toDate =>
        this.setState({toDate});

    handleSelectClaims = () =>
        this.props.onSelectClaims(this.state.fromDate, this.state.toDate);

    render() {

        return (
            <section className='system-selected-claims-modal-body'>
                <div className='row'>
                    <FormattedMessage id='SELECT_CLAIMS_WITHIN_DATE_RANGE'/>
                </div>
                <div className='row'>
                    <LabeledDateInput
                        className='from-date required'
                        date={this.state.fromDate}
                        isEditable={true}
                        isValid={true}
                        label='FROM'
                        maxDate={moment()}
                        onDateChange={this.handleFromDateChange}
                        placeholderText={this.props.dateFieldPlaceholder}
                    />
                    <LabeledDateInput
                        className='to-date required'
                        date={this.state.toDate}
                        isEditable={true}
                        isValid={true}
                        label='TO'
                        maxDate={moment()}
                        onDateChange={this.handleToDateChange}
                        placeholderText={this.props.dateFieldPlaceholder}
                    />
                </div>
                <div className='button'>
                    <button
                        className='button-primary'
                        disabled={!this.state.fromDate || !this.state.toDate}
                        onClick={this.handleSelectClaims}
                    >
                        <FormattedMessage id='SELECT_CLAIMS'/>
                    </button>
                </div>
            </section>
        );

    }

}

SystemSelectedClaimsModalBody.displayName = 'SystemSelectedClaimsModalBody';
SystemSelectedClaimsModalBody.propTypes = {
    dateFieldPlaceholder: PropTypes.string.isRequired,
    onSelectClaims: PropTypes.func.isRequired
};

export default SystemSelectedClaimsModalBody;



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/components/system-selected-claims-modal/system-selected-claims-modal-body.js